import { render } from "./CrossStep1InCorso.vue?vue&type=template&id=8fa77790"
import script from "./CrossStep1InCorso.vue?vue&type=script&lang=js"
export * from "./CrossStep1InCorso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__